export const SHARED_MARK_CODE = 'SHARED_MARK_CODE'
export const SHARED_UNMARK_CODE = 'SHARED_UNMARK_CODE'

export default {
  SHARED_MARK_CODE,
  SHARED_UNMARK_CODE
}


// WEBPACK FOOTER //
// ./src/store/shared/actionTypes.js